import React from "react";

const DiscoverLargeIcon = () => {
  return (
    <svg
      width="36"
      height="24"
      viewBox="0 0 36 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      role="img"
      aria-label="Discover"
    >
      <g clipPath="url(#clip0_discover_large)">
        <path
          d="M34.8144 0H1.18564C0.529586 0 0 0.552009 0 1.23584V22.7642C0 23.448 0.529586 24 1.18564 24H34.8144C35.4704 24 36 23.448 36 22.7642V1.23584C36 0.552009 35.4704 0 34.8144 0ZM34.2294 12C34.2294 18.3975 29.2538 23.5881 23.1122 23.5881H1.18564C1.13031 23.5881 1.07893 23.5839 1.02756 23.5716C0.976178 23.5592 0.9248 23.5428 0.877374 23.5221C0.810188 23.4933 0.746954 23.448 0.691623 23.3985C0.652103 23.3657 0.616533 23.3286 0.584916 23.2874C0.470304 23.1432 0.395214 22.9619 0.395214 22.7601V1.23584C0.395214 1.06694 0.446592 0.906282 0.529586 0.774459C0.557252 0.729146 0.588869 0.687951 0.624438 0.650876C0.695576 0.576725 0.782523 0.514934 0.877374 0.47274C0.9248 0.453141 0.976178 0.436664 1.02756 0.424305C1.07893 0.411947 1.13031 0.407828 1.18564 0.407828H23.1122C29.2497 0.407828 34.2294 5.59424 34.2294 11.9959V12Z"
          fill="url(#paint0_linear_discover_large)"
        />
        <path
          d="M3.06678 9.25305H1.66773V13.928H3.06284C3.80189 13.928 4.33937 13.7618 4.80968 13.388C5.36693 12.9462 5.69891 12.2816 5.69891 11.5943C5.69891 10.2160 4.61997 9.25305 3.07074 9.25305H3.06678ZM4.18128 12.7649C3.88092 13.0217 3.49361 13.1350 2.87708 13.1350H2.62019V10.0423H2.87708C3.49361 10.0423 3.86907 10.1480 4.18128 10.4199C4.51326 10.6993 4.71087 11.1373 4.71087 11.583C4.71087 12.0286 4.51326 12.4817 4.18128 12.7612V12.7649Z"
          fill="#261F20"
        />
        <path
          d="M7.08614 9.25305H6.13367V13.928H7.08614V9.25305Z"
          fill="#261F20"
        />
        <path
          d="M9.42188 11.0467C8.84882 10.8428 8.68283 10.7106 8.68283 10.4576C8.68283 10.1631 8.98319 9.94031 9.39413 9.94031C9.67875 9.94031 9.91589 10.0536 10.1649 10.318L10.6628 9.69486C10.2518 9.35123 9.76175 9.17725 9.22427 9.17725C8.35875 9.17725 7.69874 9.75150 7.69874 10.518C7.69874 11.1638 8.00700 11.4923 8.90415 11.7982C9.27567 11.9228 9.46929 12.0097 9.56415 12.0625C9.75386 12.1796 9.84870 12.3495 9.84870 12.5459C9.84870 12.9235 9.53253 13.2068 9.10578 13.2068C8.65113 13.2068 8.28366 12.9877 8.06241 12.5836L7.44586 13.1501C7.88445 13.7656 8.41407 14.0412 9.14119 14.0412C10.1331 14.0412 10.8286 13.4106 10.8286 12.5081C10.8286 11.7642 10.5087 11.4281 9.42188 11.1005V11.0467Z"
          fill="#261F20"
        />
        <path
          d="M11.1291 11.5943C11.1291 12.9688 12.2595 14.0336 13.7099 14.0336C14.1209 14.0336 14.4727 13.9581 14.9073 13.7618V12.6893C14.524 13.0556 14.1881 13.2029 13.7534 13.2029C12.7932 13.2029 12.1093 12.5383 12.1093 11.5905C12.1093 10.6917 12.8128 10.0056 13.7099 10.0056C14.1644 10.0056 14.5082 10.1604 14.9073 10.5105V9.43804C14.4885 9.23414 14.1446 9.15106 13.7336 9.15106C12.2871 9.15106 11.1291 10.2386 11.1291 11.598V11.5943Z"
          fill="#261F20"
        />
        <path
          d="M22.4756 12.3911L21.1674 9.25305H20.1281L22.2029 14.045H22.7167L24.8312 9.25305H23.7957L22.4756 12.3911Z"
          fill="#261F20"
        />
        <path
          d="M25.262 13.928H27.9692V13.1350H26.2145V11.8737H27.902V11.0808H26.2145V10.0461H27.9692V9.25305H25.262V13.928Z"
          fill="#261F20"
        />
        <path
          d="M31.7474 10.6314C31.7474 9.75528 31.1150 9.25305 29.9164 9.25305H28.6014V13.928H29.5539V12.0512H29.6804L31.0004 13.928H32.1742L30.6329 11.9568C31.3519 11.8171 31.7474 11.3488 31.7474 10.6314ZM29.8346 11.4016H29.5539V9.98564H29.8464C30.4393 9.98564 30.7633 10.2236 30.7633 10.6805C30.7633 11.1374 30.4393 11.4016 29.8305 11.4016H29.8346Z"
          fill="#261F20"
        />
        <path
          d="M32.5062 9.49845C32.5062 9.41537 32.4469 9.37005 32.3442 9.37005H32.2059V9.78167H32.3087V9.62317L32.4312 9.78167H32.5577L32.4153 9.61173C32.4746 9.59663 32.5103 9.55509 32.5103 9.49845H32.5062ZM32.3244 9.55509H32.3087V9.44558H32.3285C32.3798 9.44558 32.4075 9.46446 32.4075 9.49845C32.4075 9.53244 32.3798 9.55509 32.3285 9.55509H32.3244Z"
          fill="#261F20"
        />
        <path
          d="M32.364 9.21524C32.1545 9.21524 31.9886 9.37385 31.9886 9.57398C31.9886 9.77412 32.1585 9.93272 32.364 9.93272C32.5695 9.93272 32.7355 9.77034 32.7355 9.57398C32.7355 9.37762 32.5695 9.21524 32.364 9.21524ZM32.364 9.86852C32.198 9.86852 32.0636 9.73635 32.0636 9.57398C32.0636 9.41160 32.198 9.27944 32.364 9.27944C32.5299 9.27944 32.6604 9.41538 32.6604 9.57398C32.6604 9.73258 32.526 9.86852 32.364 9.86852Z"
          fill="#261F20"
        />
        <g filter="url(#filter0_i_discover_large)">
          <circle
            cx="17.7501"
            cy="11.6276"
            r="2.64908"
            fill="url(#paint1_linear_discover_large)"
          />
        </g>
      </g>
      <defs>
        <filter
          id="filter0_i_discover_large"
          x="15.1011"
          y="8.9785"
          width="5.68815"
          height="5.68815"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="BackgroundImageFix"
            result="shape"
          />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feMorphology
            radius="0.015"
            operator="erode"
            in="SourceAlpha"
            result="effect1_innerShadow_discover_large"
          />
          <feOffset dx="0.75" dy="0.75" />
          <feGaussianBlur stdDeviation="0.1875" />
          <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
          />
          <feBlend
            mode="normal"
            in2="shape"
            result="effect1_innerShadow_discover_large"
          />
        </filter>
        <linearGradient
          id="paint0_linear_discover_large"
          x1="47.9987"
          y1="66.2864"
          x2="5.22557"
          y2="-4.9576"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#F9A020" />
          <stop offset="0.5" stopColor="#F9A020" />
          <stop offset="1" stopColor="#DF5026" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_discover_large"
          x1="19.8984"
          y1="13.2793"
          x2="15.9843"
          y2="9.62301"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#EA953E" />
          <stop offset="1" stopColor="#D44B33" />
        </linearGradient>
        <clipPath id="clip0_discover_large">
          <rect width="36" height="24" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default DiscoverLargeIcon;
